import MyButton from "components/MyButton";
import { useDisableEnterKey } from "hook";
import { SubHeader } from "layout/SubHeader";
import React, { useEffect, useState } from "react";
import NotAuthorized from "../../components/NotAuthorized";
import SettingTab from "./SettingTab/tab";
import "./index.scss";
const FinancialSetting = () => {
  const [IsSettingsActive, setIsSettingsActive] = useState(true);

  let orgInfo = localStorage?.getItem("authorizedModules")
    ? JSON.parse(localStorage?.getItem("authorizedModules"))
    : [];

  useEffect(() => {
    let check =
      orgInfo !== undefined ??
      orgInfo?.map((item) => {
        if (item?.moduleName == "financial setting") {
          return setIsSettingsActive(item?.active);
        }
      });
      setIsSettingsActive(orgInfo?.find(item => item?.moduleName === "settings")?.active);
  }, []);

  useDisableEnterKey(true);


  return !IsSettingsActive ? (
    <NotAuthorized title={"settings"} />
  ) : (
    <div className="members pr-sm-12 pt-10">
      <div className="d-flex justify-content-between align-items-center settings-heading">
        <SubHeader
          className="subheader"
          {...{
            title: "Settings",
            color: "#2455EF",
          }}
        />
      </div>

      <div>
        <SettingTab />
      </div>
    </div>
  );
};

export default FinancialSetting;
